var React = require('react');

function IconArrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"icon_arrow","transform":"translate(-1751.25 -3258.875)"},[React.createElement("path",{"id":"Pfad_461","data-name":"Pfad 461","d":"M0,0,17.442,17.442,0,34.884","transform":"translate(1752 3272.333) rotate(-45)","fill":"none","stroke":"#2a2c2b","strokeWidth":"1.5","key":0}),React.createElement("line",{"id":"Linie_50","data-name":"Linie 50","y1":"22","x2":"22","transform":"translate(1754 3273)","fill":"none","stroke":"#2a2c2b","strokeWidth":"1.5","key":1})]));
}

IconArrow.defaultProps = {"width":"38.875","height":"38.875","viewBox":"0 0 38.875 38.875"};

module.exports = IconArrow;

IconArrow.default = IconArrow;
